<template>
    <b-row>
        <div class="col-sm-12 mt-3">
            <h3>
                Reporte por vendedor
            </h3>
        </div>
        <b-col sm="2" class="mt-3">
            <label for="">Sucursal</label>
            <select class="form-control form-control-sm" v-model="sucursal" @change="setear_sucursal_origen">
                <option value="">Seleccionar</option>
                <option v-for="(item, index) in SUCURSALES_SIN_BODEGA_CENTRAL" :key="index" :value="item.codigo">{{
                    item.nombre }}</option>
            </select>
        </b-col>
        <b-col sm="2" class="mt-3">
            <label for="">Vendedor</label>
            <select class="form-control form-control-sm" v-model="usuario__" @change="limpiar_lista">
                <option value="">Seleccionar</option>
                <option v-for="(item, index) in usuarios" :key="index" :value="item.id">{{ item.nombre_completo }}
                </option>
            </select>
        </b-col>

        <b-col sm="3" class="mt-3">
            <label for="">Fecha inicial</label>
            <b-form-input type="date" size="sm" v-model="fecha_inicial"></b-form-input>
        </b-col>

        <b-col sm="3" class="mt-3">
            <label for="">Fecha final</label>
            <b-form-input type="date" size="sm" v-model="fecha_final"></b-form-input>
        </b-col>
        <!-- <b-col sm="4" class="mt-3">
            <label for="" class="form-label">Producto</label>
            <input type="text" list="productos__" @keyup="buscar_producto"
                :disabled="FILTRAR_PRODUCTOS_POR_SUCURSAL.length === 0" class="form-control form-control-sm"
                v-model="producto">
            <datalist id="productos__">
                <option v-for="(item, index) in FILTRAR_PRODUCTOS_POR_SUCURSAL" :key="index" :value="item.codigo">
                    {{
                        item.nombre
                    }}
                </option>
            </datalist>
        </b-col> -->
        <!-- <b-col sm="10" class="mt-3">
            <label for="" class="form-label">Nombre</label>
            <input type="text" class="form-control form-control-sm" readonly v-model="nombre_producto">
        </b-col> -->
        <b-col sm="2" class="mt-5">
            <b-button block type="button" variant="info" size="sm" @click="buscar">Buscar</b-button>
        </b-col>

        <b-col sm="12" class="mt-3">
            <div class="marco_bitacora" style="height: calc(100vh - 360px);">
                <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                    <thead>
                        <tr>
                            <th style="width: 10%;text-align: center;">
                                Fecha
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Serie
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Número
                            </th>
                            <th style="width: 50%;">
                                Nombre cliente
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Tipo de documento
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Sub Total
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in registros.datos" :key="index">
                            <td style="text-align: center;">
                                {{ item.fecha_movimiento }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.sat_serie }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.sat_numero }}
                            </td>
                            <td>
                                {{ item.nombre_cliente }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.sat_tipo_documento }}
                            </td>
                            <td style="text-align: center;">
                                Q{{ item.total_movimiento.toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) }}
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td style="text-align: center;">Gran total</td>
                            <td style="text-align: center;">Q{{ gran_total.toLocaleString(undefined, {
                                minimumFractionDigits: 2, maximumFractionDigits: 2
                            }) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-col>
    </b-row>
</template>

<script>
    import { minix } from '@/components/functions/alertas';
    import moment from 'moment';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

    export default {
        name: 'ReportePorVendedor',
        computed: {
            ...mapState(['id_empresa_seleccionada']),
            ...mapGetters(['FILTRAR_PRODUCTOS_POR_SUCURSAL', 'SUCURSALES_SIN_BODEGA_CENTRAL'])
        },
        data() {
            return {
                sucursal: '',
                usuario__: '',
                usuarios: [],
                fecha_inicial: moment(Date.now()).format('YYYY-MM-DD'),
                fecha_final: moment(Date.now()).format('YYYY-MM-DD'),
                registros: [],
                gran_total: 0,
                producto: '',
                producto_filtrado: '',
                nombre_producto: '-'
            }
        },
        methods: {
            async obtener_usuarios_por_sucursal() {
                if (this.sucursal != '') {
                    // let r = await axios.get(`${this.URL_SERVIDOR}/api/users?filters[sucursal_asignada][$eq][0]=${this.sucursal}&filters[empresa][$eq][1]=${this.id_empresa_seleccionada}`, this.TOKEN_FORMATEADO)

                    let f = {
                        api: `sucursales-asignadas/c/usuarios?sucursal=${this.sucursal}&empresa=${this.id_empresa_seleccionada}`
                    }

                    let r = await this.obtener_data(f)

                    if (r.length == 0) {
                        minix({ icon: 'info', mensaje: 'No hay registros', tiempo: 3000 })
                        this.usuarios = []
                        this.usuario__ = ''
                    } else {
                        this.usuarios = r
                    }
                } else {
                    this.usuarios = []
                }
            },
            async buscar() {
                if (this.producto == '') {
                    if (this.sucursal == '' || this.usuario__ == '') {
                        minix({ icon: 'error', mensaje: 'Selecciona una sucursal y un vendedor', tiempo: 3000 })
                    } else {

                        let f = {
                            api: `movimientos-cabeceras/q/reporte_por_vendedor?fecha_inicial=${this.fecha_inicial}&fecha_final=${this.fecha_final}&sucursal=${this.sucursal}&usuario=${this.usuario__}&empresa=${this.id_empresa_seleccionada}`

                        }

                        let r = await this.obtener_data(f)
                        if (r.datos.length == 0) {
                            minix({ icon: 'info', mensaje: 'No hay registros', tiempo: 3000 })
                        } else {
                            this.registros = r
                            this.gran_total = r.total

                        }

                    }
                } else {
                    if (this.sucursal == '' || this.usuario__ == '') {
                        minix({ icon: 'error', mensaje: 'Selecciona una sucursal y un usuario', tiempo: 3000 })
                    } else {

                        let f = {
                            api: `movimientos-cabeceras/q/reporte_por_vendedor?fecha_inicial=${this.fecha_inicial}&fecha_final=${this.fecha_final}&sucursal=${this.sucursal}&usuario=${this.usuario__}&empresa=${this.id_empresa_seleccionada}&producto=${this.producto}`

                        }

                        let r = await this.obtener_data(f)
                        if (r.datos.length == 0) {
                            minix({ icon: 'info', mensaje: 'No hay registros', tiempo: 3000 })
                        } else {
                            this.registros = r
                            this.gran_total = r.total
                        }

                    }
                }
            },
            buscar_producto() {
                let filtro = this.FILTRAR_PRODUCTOS_POR_SUCURSAL.filter(item => item.codigo == this.producto)
                if (filtro.length != 0) {
                    this.productos_filtrados = filtro[0]
                    this.nombre_producto = filtro[0].nombre

                }

            },
            setear_sucursal_origen() {
                // ESTO ES PARA QUE FILTRE LOS PRODUCTOS POR SUCURSAL
                this.set_filtro_productos_sucursales_traslados(parseInt(this.sucursal))
                this.limpiar_lista()

            },
            limpiar_lista() {
                this.producto = ''
                this.nombre_producto = '-'
                this.registros = []
                this.gran_total = 0
            },
            ...mapActions(['obtener_data']),
            ...mapMutations(['set_filtro_productos_sucursales_traslados'])
        },
        mounted() {
            this.set_filtro_productos_sucursales_traslados('')
        },
        watch: {
            sucursal() {
                this.obtener_usuarios_por_sucursal()
            }
        }
    }
</script>

<style></style>